/**
 * Public marketing routes, for the app router (`web/src/routes.js`). Every page module exports
 * `render(el, params)` (returns a cleanup fn) and a pure `view(params)` used by the prerender
 * (`web/scripts/prerender.js`). `title`/`description` are defaults; pages set their own head.
 *
 * @type {{ path: string, load: () => Promise<any>, title: string, description: string }[]}
 */
export const marketingRoutes = [
  {
    path: '/',
    load: () => import('./pages/home.js'),
    title: 'Fair Play Deck: share the invisible work of home, fairly',
    description: 'A digital deck for Eve Rodsky’s Fair Play system. Fair, not 50/50.',
  },
  {
    path: '/how-it-works',
    load: () => import('./pages/how-it-works.js'),
    title: 'How Fair Play works',
    description: 'The four rules, CPE, MSC, Daily Grinds, Wild cards and weekly check-ins.',
  },
  {
    path: '/cards',
    load: () => import('./pages/cards.js'),
    title: 'All 100 Fair Play cards',
    description: 'Every card in the Fair Play deck, by suit.',
  },
  {
    path: '/cards/:slug',
    load: () => import('./pages/card.js'),
    title: 'Fair Play card',
    description: 'A card from the Fair Play deck by Eve Rodsky.',
  },
  {
    path: '/about',
    load: () => import('./pages/about.js'),
    title: 'About Fair Play Deck',
    description: 'An unofficial prototype built for Eve Rodsky.',
  },
];

export default marketingRoutes;
export const routes = marketingRoutes;
